import { useAppStore } from "@/common/store/appStore";
import { useEffect, useRef, useCallback } from "react";
import { useScrollStore } from "@/common/store/scrollStore";

const SCROLL_THRESHOLD = 10;

export const useHeaderScroll = () => {
  const prevScrollY = useRef(0);
  const isSearchBarOpen = useAppStore((state) => state.isSearchBarOpen);
  const scrollElement = useScrollStore(state => state.scrollElement);

  const handleScroll = useCallback(() => {
    const currentScrollY = scrollElement?.scrollTop ?? 0;
    const prevScroll = prevScrollY.current < 0 ? 0 : prevScrollY.current;
    const scrollDifference = Math.abs(currentScrollY - prevScroll);

    if (currentScrollY === 0) {
      scrollElement?.classList.remove("scrolled");
      scrollElement?.classList.remove("scrolledUp");
      prevScrollY.current = 0;
      return;
    }

    if (scrollDifference <= SCROLL_THRESHOLD) {
      return;
    }

    const isScrolledDown = currentScrollY > prevScroll;
    prevScrollY.current = currentScrollY;

    if (isScrolledDown) {
      scrollElement?.classList.add("scrolled");
      scrollElement?.classList.remove("scrolledUp");
    } else {
      scrollElement?.classList.remove("scrolled");
      if (currentScrollY > 0) {
        scrollElement?.classList.add("scrolledUp");
      } else {
        scrollElement?.classList.remove("scrolledUp");
      }
    }
  }, [scrollElement]);

  useEffect(() => {
    const currentWrapper = scrollElement;
    if (!currentWrapper || isSearchBarOpen) {
      return;
    }

    currentWrapper.addEventListener("scroll", handleScroll);
    return () => {
      currentWrapper.removeEventListener("scroll", handleScroll);
    };
  }, [scrollElement, handleScroll, isSearchBarOpen]);
};
